<template>
    <v-container>
        <v-row v-if="error">
            <v-col cols="12" sm="6" offset-sm="3">
                <v-alert color="error" dismissible>
                    {{ error }}
                </v-alert>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="6" offset-sm="3">
                <v-card>
                    <form @submit.prevent="onSubmit" ref="resetPasswordForm">
                        <v-card-title>Nastavení nového hesla</v-card-title>
                        <v-card-text>
                            <div v-if="isVerifying">
                                <v-progress-linear :indeterminate="true"></v-progress-linear>
                                <p>Probíhá ověřování, čekejte prosím...</p>
                            </div>
                            <div v-else-if="!canSetNewPassword">
                                <p>Nové heslo nelze nastavit.</p>
                            </div>
                            <div v-if="canSetNewPassword">
                                <v-text-field
                                        label="Nové heslo"
                                        v-model.trim="newPassword"
                                        type="password"
                                        :rules="rules.newPassword"
                                        validate-on-blur
                                ></v-text-field>
                                <v-text-field
                                        label="Nové heslo znovu"
                                        v-model.trim="newPasswordRepeat"
                                        type="password"
                                        :rules="rules.newPasswordRepeat"
                                        validate-on-blur
                                ></v-text-field>
                            </div>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions v-if="canSetNewPassword">
                            <v-spacer></v-spacer>
                            <v-btn type="submit" class="primary" :disabled="loading || !isFormValid" :loading="loading">
                                Odeslat
                            </v-btn>
                        </v-card-actions>
                    </form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapState } from 'vuex'
    import { validator } from '../plugins/validator'
    import { CHANGE_LOST_PASSWORD_REQUEST, VERIFY_LOST_PASSWORD_REQUEST } from '../store/actions/user'

    export default {
        props: {
            token: {
                type: String,
                required: true,
            },
        },
        data () {
            return {
                newPassword: '',
                newPasswordRepeat: '',
                isVerifying: false,
                error: null,
                loading: false,
            };
        },
        computed: {
            comparePassword () {
                return this.newPassword === this.newPasswordRepeat || 'Hesla musí být stejná.';
            },
            isFormValid () {
                return this.canSetNewPassword
                    && this.newPassword !== ''
                    && this.comparePassword === true;
            },
            canSetNewPassword () {
                return this.token !== '' && this.error === null && !this.isVerifying;
            },
            rules () {
                return {
                    newPassword: [validator.required, validator.password],
                    newPasswordRepeat: [validator.required, this.comparePassword],
                };
            },
        },
        async created () {
            try {
                this.isVerifying = true;
                await this.$store.dispatch('user/' + VERIFY_LOST_PASSWORD_REQUEST, { token: this.token });
            } catch (e) {
                this.error = e.response.data.message || 'Došlo k chybě. Zkuste to později.';
            } finally {
                this.isVerifying = false;
            }
        },
        methods: {
            async onSubmit () {
                if (!this.isFormValid) {
                    return;
                }
                const data = {
                    token: this.token,
                    newPassword: this.newPassword,
                };

                try {
                    this.loading = true;
                    await this.$store.dispatch('user/' + CHANGE_LOST_PASSWORD_REQUEST, data);
                    this.$refs.resetPasswordForm.reset();
                    this.$toast.success('Heslo bylo úspěšně změněno. Nyní se můžete přihlásit.');
                    await this.$router.push({ name: 'signIn' });
                } catch (e) {
                    const message = e.response.data.message || 'Došlo k chybě. Zkuste to později.';
                    this.$toast.error(message);
                } finally {
                    this.loading = false;
                }
            },
        },
    }
</script>
